"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initNProgress = void 0;
var router_1 = __importDefault(require("next/router"));
var nprogress_1 = __importDefault(require("nprogress"));
function initNProgress() {
    var timer;
    var delay = 500;
    nprogress_1.default.configure({ showSpinner: false, trickleSpeed: 100 });
    var handleStartLoading = function () {
        timer = setTimeout(function () {
            nprogress_1.default.start();
        }, delay);
    };
    var handleStopLoading = function () {
        clearTimeout(timer);
        nprogress_1.default.done();
    };
    router_1.default.events.on('routeChangeStart', handleStartLoading);
    router_1.default.events.on('routeChangeComplete', handleStopLoading);
    router_1.default.events.on('routeChangeError', handleStopLoading);
}
exports.initNProgress = initNProgress;
